'use client';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="en">
      <body>
        <h3>{error.message}</h3>
        <button type="button" onClick={reset}>
          Go back
        </button>
      </body>
    </html>
  );
}
